import { useAppSelector } from 'flow/hooks/useRedux';

import { ExtensionKey } from 'flow/types/EntityKeys';
import { Extension, Statuses } from 'flow/types/Extension';

import { TypedMap } from 'flow/types/TypedMap';
import { ChatMember } from 'flow/types/Chats';

interface ExtensionHook {
    ownExtension: TypedMap<Extension>;
    extension: TypedMap<Extension>;
    status: Statuses;
    isOwnChatUser: (member: TypedMap<ChatMember>) => boolean;
}

const useExtension = (key?: ExtensionKey): ExtensionHook => {
    const ownExtensionKey = useAppSelector((state) =>
        state.app?.getIn(['extension', 'key']),
    );

    const ownExtension = useAppSelector((state) =>
        state.extensions?.getIn(['extensions', ownExtensionKey]),
    );

    const extension = useAppSelector((state) =>
        state.extensions?.getIn(['extensions', key]),
    );

    const status = useAppSelector((state) =>
        state.extensions?.getIn(['statuses', key], 'unknown'),
    );

    const isOwnChatUser = (member: TypedMap<ChatMember>) =>
        member.get('key') === ownExtension.get('chatUserKey');

    return { ownExtension, extension, status, isOwnChatUser };
};

export default useExtension;
